import axios from 'axios';
// this will get refactored to use an API instead of window properties in the near future
const url = window.ACC?.config?.encodedContextPath;
const storefrontAxiosConfig = {
  baseUrl: url,
};

export default axios.create({baseURL: storefrontAxiosConfig.baseUrl});
